import React from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../stateProvider/StateProvider';
import Button from '../forms/Button';
import Modal from '../Modal';
import Col from '../layout/Col';
import Heading from '../forms/Heading';
import Title from '../forms/Title';
import ModalFactory from '../Modal';

const Indent = styled.span`
    padding-left: 0.5em;
`

const ToS = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
        acceptTos
    } = useGlobalState();

    return (
        <Col>
            <Title>SERVICE AGREEMENT</Title>
            <span>
                <b>
                    PLEASE READ THIS TERMS OF USE AGREEMENT ("AGREEMENT") CAREFULLY BEFORE USING THE
                    HAMILTON MANUFACTURING SOFTWARE. BY USING THIS SOFTWARE, YOU ARE AGREEING TO BE
                    BOUND BY THE TERMS OF THIS AGREEMENT. BY CHECKING THE BOX BELOW AND PROCEEDING TO
                    USE THE SERVICES, YOU AGREE TO ITS TERMS.
                </b>
            </span>

            <Heading>1. GENERAL PROVISIONS</Heading>
            <span>
                This is an agreement between you ("User") and Hamilton Manufacturing Corporation ("The
                Company"). This Agreement governs your usage of and access to the Internet database and any
                software, service, web site, or web page operated by the Company (collectively, the "Services").
                Use of the Services is exclusively for individuals or businesses that can form a legally binding
                contract at the time usage commences. When providing the Services, Company acts as an
                interactive computer service as defined in 47 U.S. Code Section 230(f)(2). Authorized Users are
                those that are in a current contract with Hamilton Manufacturing Corporation solely for the
                purposes of viewing account data on the database. Only authorized Users are permitted. Any
                unauthorized Users will be pursued under applicable law. The Company offers use of the Services
                to the authorized User in exchange and consideration of a monthly User fee conditioned on your
                acceptance of this Agreement. By clicking on the box below, you accept its terms under this legally
                binding agreement.
            </span>


            <Heading>2. WHAT YOU RECEIVE</Heading>
            <span>
                Use of the Services is the property of the Company. During the term of your agreement, the
                Company grants to User revocable, limited, non-transferable, non-exclusive access to the
                Company's Services, solely with the purpose of reviewing your data backed up to the server. The
                Company retains all rights, title, and interest in and to the Services, all copies thereof, and all rights
                therein, including copyrights, patent, trademark and trade secret rights. User does not acquire any
                ownership rights to the Services through your use. User and the Company expressly agree not to
                modify any settings or use the database service in any way not within the terms of this agreement.
                User may not copy or distribute the services. User may not reverse engineer, decompile,
                disassemble, modify, or create derivative works of the Services provided by Hamilton
                Manufacturing or its agents.
            </span>

            <Heading>3. CONSENT TO USE DATA</Heading>
            <Indent>
                <b><i>A.</i></b> Diagnostic and Usage Data. User agrees that Hamilton Manufacturing Corporation and its
                subsidiaries and agents may collect, maintain, process and use diagnostic, technical, usage
                and related information, including but not limited to the information about you, that is
                gathered periodically to facilitate updates, product support and other services to you.
            </Indent>

            <Heading>4. TERM LENGTH, RENEWAL AND TERMINATION</Heading>
            <Indent>
                <b><i>A.</i></b> The term of this Agreement shall be from the date you enter into this Agreement until it is
                terminated by The Company or the User on giving at least 30 days written notice of
                termination to the other party. This Agreement is effective until terminated regardless of
                the foregoing. The Company may terminate it at any time and expressly reserves the right
                to terminate the agreement at its sole discretion.
            </Indent>
            <Indent>
                <b><i>B.</i></b> The term of this agreement runs concurrently with the period during which the User has a
                contractual relationship with the Company for the purpose of uploading and viewing
                consumer data set forth in this agreement.
            </Indent>
            <Indent>
                <b><i>C.</i></b> This agreement shall terminate, unless otherwise set forth by the Company, if User fails to
                comply with any term or condition of this Agreement. In such event, no notice shall be
                required by the Company to effect such termination.
            </Indent>

            <Indent>
                <b><i>D.</i></b> Upon termination, your agreement to use the Services terminates effective immediately.
                Monthly access fees will not be refunded or prorated.
            </Indent>

            <Heading>5. CHARGES AND PAYMENT</Heading>
            <Indent>
                <b><i>A.</i></b> The Company will charge User a service fee for each of the Services User selects, plus any
                applicable sale, use, value-added, personal property, or other governmental tax imposed
                on the Service. Current rates are available through the representative agent or by
                telephone to the Company's home office.
            </Indent>
            <Indent>
                <b><i>B.</i></b> If User qualifies as an open account, the Company will send you an invoice due and payable
                within 30 days after the date of invoice. If User chooses to pay by credit card, the Company
                will automatically bill the monthly service fee to your credit card account on the 15th day
                of each month.
            </Indent>
            <Indent>
                <b><i>C.</i></b> User is responsible for obtaining, installing, maintaining, and operating all computer
                equipment and for charges necessary to access the Services.
            </Indent>



            <Heading>6. RESTRICTIONS ON USE</Heading>
            <Indent>
                <Col>
                    <span>
                        <b><i>A.</i></b> Except for the initial uploading of data for archival/backup purposes as provided above,
                        User shall not, without Company's express written consent:
                    </span>
                    <Indent>
                        <b>1.</b> Copy or reproduce the Services.
                    </Indent>
                    <Indent>
                        <b>2.</b> Electronically transfer the Services through a LAN (local area network) or
                        other network system or through any computer subscriber system,
                        "bulletin board" system, or any other system not mentioned in this
                        agreement.
                    </Indent>
                    <Indent>
                        <b>3.</b> Modify, adapt, or create derivative works based on the Services or any
                        accompanying materials.
                    </Indent>
                    <Indent>
                        <b>4.</b> Use the Services in any way that is unlawful, or harms the Company, its
                        affiliates, resellers, distributors, service providers and / or suppliers or any
                        customer of Hamilton Manufacturing Corporation.
                    </Indent>
                    <Indent>
                        <b>5.</b> Use the Services in any manner that could damage, disable, overburden, or
                        impair any element of the Services or interfere with any other party's use
                        and enjoyment of the Services.
                    </Indent>
                    <Indent>
                        <b>6.</b> Upload, download, display, perform, transmit, or other distribute any
                        content that is libelous, defamatory, obscene, pornographic, abusive, or
                        threatening; advocate or encourages conduct that could constitute a
                        criminal defense, give rise to civil liability, or otherwise violate any
                        applicable local, state, national, or foreign law or regulation.
                    </Indent>
                    <Indent>
                        <b>7.</b> Violate or attempt to violate any security features of the Services
                        including without limitation, (a) accessing content or data not intended for
                        User, or logging onto a server or account that User is not authorized to
                        access; (b) attempt to probe, scan, or test the vulnerability of the Services
                        or any associated system or network, or to breach security or
                        authentication measures without proper authorization; and(c) interfering
                        or attempting to interfere with service to any user by any means, including
                        viruses.
                    </Indent>
                    <Indent>
                        <b>8.</b> Engage in any copyright infringement or other intellectual property
                        infringement (including uploading any content which User does not have
                        the right to upload), or disclose any trade secrets or confidential
                        information in violation of a confidential, employment, or nondisclosure
                        agreement.
                    </Indent>
                    <Indent>
                        <b>9.</b> User will provide to The Company notice of any use of or access to the
                        Services that is not authorized by you.
                    </Indent>
                </Col>
            </Indent>




            <Heading>7. CONFIDENTIAL INFORMATION</Heading>
            <Indent>
                <b><i>A.</i></b> Confidential information includes any information relating to or disclosed in the course of
                the Agreement, which is or should be reasonably understood to be confidential or
                proprietary to the disclosing party, during the initial term or any renewal term. Examples
                include, but are not limited to, the material terms of this Agreement, information about
                the Company or User, technical processes and formulas, source codes, product designs,
                sales, costs and other unpublished financial information, product and business plans,
                projections, and marketing data. User expressly agrees to prevent the duplication or
                disclosure of confidential information, other than by or to its employees or agents who must have access to the confidential information to perform such party's obligations
                hereunder.
            </Indent>
            <Indent>
                <b><i>B.</i></b> Electronic transmissions passing through the Services or over the Internet and through
                Company's system are not secure, and the Company cannot guarantee the security or
                privacy of any of User's information or communications. Company will not intentionally
                monitor or disclose any private electronic communications, except to the extent necessary
                to identify or resolve system problems or as otherwise permitted or required by law.
                C. The Company expressly reserves the right to refuse Service to anyone.
            </Indent>

            <Heading>8. NO WARRANTIES / LIMITATION OF LIABILITY / DISCLAIMER</Heading>
            <Indent>
                <b><i>A.</i></b> User shall assume responsibility for the installation, use, and results obtained from the
                Services.
            </Indent>
            <Indent>
                <b><i>B.</i></b> This provision transfers to the User the responsibility for using the program.
            </Indent>
            <Indent>
                <b><i>C.</i></b> THE SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS
                OR IMPLIED, INCLUDING, WITHOUT LIMITATION TO, THE IMPLIED WARRANTIES OF
                MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. THE COMPANY DOES NOT
                WARRANT THAT THE FUNCTIONS CONTAINED IN THE PROGRAM WILL MEET YOUR
                REQUIREMENTS OR THAT THE OPERATION OF THE PROGRAM WILL BE UNINTERRUPTED
                OR ERROR FREE. IN NO EVENT SHALL THE COMPANY BE LIABLE FOR ANY INDIRECT,
                INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR PUNITIVE DAMAGES, EVEN IF ADVISED OF THE
                POSSIBILITY OF SUCH DAMAGES. THE MAXIMUM LIABILITY OF COMPANY TO ANY USER
                FOR ANY LOSS, CLAIM, DAMAGE, OR LIABILITY OF ANY KIND, INCLUDING DUE TO
                COMPANY'S NEGLIGENCE, SHALL BE LIMITED TO THE AMOUNT PAID BY USER TO
                COMPANY DURING THE TERM OF ITS USAGE. The entire risk as to the quality and
                performance of the Services is with User. Should the Services prove defective, User
                assumes the entire cost of all necessary servicing, repair, or correction. User expressly
                agrees to hold harmless the Company from any costs related to servicing, repair, or
                correction to the Services or its data.
            </Indent>
            <Indent>
                <b><i>D.</i></b> User understands and agrees to indemnify and hold Company, its officers, directors,
                employees, and agents harmless from and against any claims or expenses (including
                reasonably attorney's fees) arising out of or related to any violation of this Agreement or
                use of User account, made by a third party. This obligation shall survive the termination or
                expiration of this Agreement and / or your use of the Services.
            </Indent>

            <Heading>9. QUESTIONS</Heading>
            <Indent>
                <b><i>A.</i></b> All questions concerning this Agreement may be directed to the Customer Service
                Department, 1026 Hamilton Drive, Holland, OH 43528, (419) 867-4858.
            </Indent>


            <Heading>10. JURISDICTION AND DISPUTES</Heading>
            <Indent>
                <b><i>A.</i></b> This Agreement shall be interpreted, construed and enforced in all respects in accordance
                with the laws of the State of Ohio, United State of America.
            </Indent>
            <Indent>
                <b><i>B.</i></b> All disputes hereunder shall be resolved in the applicable state or federal courts of Ohio.
                The parties irrevocably consent to the jurisdiction of such courts, in connection with any
                action to enforce the provisions of this Agreement, to recover damages or other relief for
                breach or default under this Agreement, or otherwise arising under or by reason of this
                Agreement. The parties expressly agree to accept service of process by mail, and expressly
                waive any jurisdiction or venue defenses otherwise available.
            </Indent>
            <Indent>
                <b><i>C.</i></b> User agrees to waive any and all disputes, now known or later discovered, that User may
                have against the Company and its affiliates arising out of your use of the Services after six
                months beginning on the usage date of the Services. Any claim after this period is expressly
                waived.
            </Indent>

            <Heading>11. ENTIRE AGREEMENT</Heading>
            <Indent>
                <b><i>A.</i></b> This agreement incorporates all prior or contemporary communications or understanding
                by the Company and the User. It may only be modified by written agreement agreed to by
                both the User and the Company.
            </Indent>

            <Heading>12. NON - ASSIGNABILITY</Heading>
            <Indent>
                <b><i>A.</i></b> Neither party may assign to any other party any of its rights or obligations under this
                Agreement.
            </Indent>

            <b>
                USER HEREBY ACKNOWLEDGES THAT IT HAS READ THIS AGREEMENT, UNDERSTANDS IT AND
                AGREES TO BE BOUND BY ITS TERMS AND CONDITIONS. BY CLICKING ON THE BOX, "I ACCEPT,"
                BELOW, YOU EXPRESSLY AGREE TO THESE TERMS AND CONDITIONS AND UNDERSTAND THAT THEY
                WILL BE LEGALLY BINDING ON YOU, ANY END USER, AND THE COMPANY.
            </b>
            {
                !active_user.tosAccepted ?
                    <Button
                        label='I Accept'
                        onClick={() => {
                            acceptTos();
                            ModalFactory.close('ToS');
                        }}
                    /> : null
            }
        </Col>

    );
}

export default ToS;